// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.strategies-page {
  max-width: 1040px;
  margin: 0 auto;
  padding: 24px 16px 64px;
  --strat-good: #2e7d46;
  --strat-warn: #b8862b;
  --strat-bad: #b8483c;
}

@media (prefers-color-scheme: dark) {
  .strategies-page {
    --strat-good: #6bbf82;
    --strat-warn: #d4a84a;
    --strat-bad: #e08a7a;
  }
}

.strat-subtabs {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.strat-subtabs button {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #444;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 13px;
}

.strat-subtabs button.active {
  background: #4a90d9;
  border-color: #4a90d9;
  color: #fff;
}

.strat-refresh {
  margin-left: auto;
}

.strat-date-input {
  padding: 5px 8px;
  border-radius: 6px;
  border: 1px solid #444;
  background: transparent;
  color: inherit;
}

.strat-muted {
  opacity: 0.6;
  font-size: 13px;
}

.strat-error {
  color: #e08a7a;
}

.strat-card {
  border: 1px solid #444;
  border-radius: 10px;
  padding: 18px 20px;
  max-width: 560px;
}

.strat-card-head {
  display: flex;
  gap: 10px;
  align-items: baseline;
  margin-bottom: 10px;
  font-weight: 600;
}

.strat-symbol { font-size: 16px; }
.strat-date { opacity: 0.6; font-size: 13px; font-weight: 400; }
.strat-buysell { font-size: 12px; padding: 1px 6px; border-radius: 10px; background: #333; }
.strat-pnl.pos { color: #6bbf82; }
.strat-pnl.neg { color: #e08a7a; }

.strat-strategy-label {
  font-size: 13px;
  opacity: 0.8;
  margin-bottom: 6px;
}

.strat-reasoning {
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 16px;
}

.strat-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.strat-btn {
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid #444;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 13px;
}

.strat-btn.primary {
  background: #2e7d46;
  border-color: #2e7d46;
  color: #fff;
}

.strat-btn.danger {
  background: #b8483c;
  border-color: #b8483c;
  color: #fff;
}

.strat-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
  border-top: 1px solid #333;
  padding-top: 12px;
}

.strat-picker-option {
  padding: 5px 10px;
  border-radius: 14px;
  border: 1px solid #444;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 12px;
}

.strat-queue-count {
  margin-top: 12px;
}

.strat-table-wrap {
  overflow-x: auto;
}

.strat-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.strat-table th {
  text-align: left;
  padding: 6px 10px;
  border-bottom: 1px solid #444;
  opacity: 0.7;
  font-weight: 600;
  white-space: nowrap;
}

.strat-table td {
  padding: 6px 10px;
  border-bottom: 1px solid #2a2a2a;
  white-space: nowrap;
}

.strat-table td.pos { color: #6bbf82; }
.strat-table td.neg { color: #e08a7a; }

/* Stat tiles per strategy */
.strat-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin: 16px 0 28px;
}

.strat-tile {
  border: 1px solid #444;
  border-radius: 10px;
  padding: 14px 16px;
}

.strat-tile-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 10px;
  gap: 8px;
}

.strat-tile-name {
  font-size: 13px;
  font-weight: 600;
}

.strat-tile-pnl {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.strat-tile-bar-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.strat-tile-bar-track {
  flex: 1 1;
  height: 6px;
  border-radius: 3px;
  background: #333;
  overflow: hidden;
}

.strat-tile-bar-fill {
  height: 100%;
  border-radius: 3px;
}

.strat-tile-pct {
  font-size: 13px;
  font-weight: 700;
  min-width: 38px;
  text-align: right;
}

.strat-tile-meta {
  display: flex;
  justify-content: space-between;
  font-size: 11.5px;
  opacity: 0.65;
}

.strat-section-title {
  font-size: 15px;
  margin: 24px 0 4px;
}

/* Discipline vs. outcome chart */
.strat-discipline-chart {
  margin: 14px 0 28px;
  max-width: 640px;
}

.strat-chart-legend {
  display: flex;
  gap: 16px;
  font-size: 12px;
  opacity: 0.8;
  margin-bottom: 10px;
}

.strat-chart-legend .dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-right: 5px;
}

.strat-chart-legend .dot.win { background: var(--strat-good); }
.strat-chart-legend .dot.loss { background: var(--strat-bad); }

.strat-chart-row {
  display: grid;
  grid-template-columns: 150px 1fr auto;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.strat-chart-label {
  font-size: 12.5px;
  opacity: 0.85;
}

.strat-chart-track {
  display: flex;
  height: 16px;
  border-radius: 4px;
  overflow: hidden;
  background: #2a2a2a;
  min-width: 20px;
}

.strat-chart-seg {
  height: 100%;
}

.strat-chart-seg.win { background: var(--strat-good); }
.strat-chart-seg.loss { background: var(--strat-bad); }
.strat-chart-seg.win + .strat-chart-seg.loss { border-left: 2px solid #1a1a1a; }

.strat-chart-count {
  font-size: 12px;
  opacity: 0.7;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/Strategies.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE;IACE,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB,eAAe,EAAE;AACjC,cAAc,YAAY,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/D,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC3F,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;;AAEjC;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,cAAc,EAAE;;AAEtC,4BAA4B;AAC5B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,+BAA+B,6BAA6B,EAAE;AAC9D,gCAAgC,4BAA4B,EAAE;;AAE9D;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,uBAAuB,6BAA6B,EAAE;AACtD,wBAAwB,4BAA4B,EAAE;AACtD,+CAA+C,8BAA8B,EAAE;;AAE/E;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".strategies-page {\n  max-width: 1040px;\n  margin: 0 auto;\n  padding: 24px 16px 64px;\n  --strat-good: #2e7d46;\n  --strat-warn: #b8862b;\n  --strat-bad: #b8483c;\n}\n\n@media (prefers-color-scheme: dark) {\n  .strategies-page {\n    --strat-good: #6bbf82;\n    --strat-warn: #d4a84a;\n    --strat-bad: #e08a7a;\n  }\n}\n\n.strat-subtabs {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.strat-subtabs button {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid #444;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.strat-subtabs button.active {\n  background: #4a90d9;\n  border-color: #4a90d9;\n  color: #fff;\n}\n\n.strat-refresh {\n  margin-left: auto;\n}\n\n.strat-date-input {\n  padding: 5px 8px;\n  border-radius: 6px;\n  border: 1px solid #444;\n  background: transparent;\n  color: inherit;\n}\n\n.strat-muted {\n  opacity: 0.6;\n  font-size: 13px;\n}\n\n.strat-error {\n  color: #e08a7a;\n}\n\n.strat-card {\n  border: 1px solid #444;\n  border-radius: 10px;\n  padding: 18px 20px;\n  max-width: 560px;\n}\n\n.strat-card-head {\n  display: flex;\n  gap: 10px;\n  align-items: baseline;\n  margin-bottom: 10px;\n  font-weight: 600;\n}\n\n.strat-symbol { font-size: 16px; }\n.strat-date { opacity: 0.6; font-size: 13px; font-weight: 400; }\n.strat-buysell { font-size: 12px; padding: 1px 6px; border-radius: 10px; background: #333; }\n.strat-pnl.pos { color: #6bbf82; }\n.strat-pnl.neg { color: #e08a7a; }\n\n.strat-strategy-label {\n  font-size: 13px;\n  opacity: 0.8;\n  margin-bottom: 6px;\n}\n\n.strat-reasoning {\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 16px;\n}\n\n.strat-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.strat-btn {\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: 1px solid #444;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.strat-btn.primary {\n  background: #2e7d46;\n  border-color: #2e7d46;\n  color: #fff;\n}\n\n.strat-btn.danger {\n  background: #b8483c;\n  border-color: #b8483c;\n  color: #fff;\n}\n\n.strat-picker {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 12px;\n  border-top: 1px solid #333;\n  padding-top: 12px;\n}\n\n.strat-picker-option {\n  padding: 5px 10px;\n  border-radius: 14px;\n  border: 1px solid #444;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.strat-queue-count {\n  margin-top: 12px;\n}\n\n.strat-table-wrap {\n  overflow-x: auto;\n}\n\n.strat-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.strat-table th {\n  text-align: left;\n  padding: 6px 10px;\n  border-bottom: 1px solid #444;\n  opacity: 0.7;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.strat-table td {\n  padding: 6px 10px;\n  border-bottom: 1px solid #2a2a2a;\n  white-space: nowrap;\n}\n\n.strat-table td.pos { color: #6bbf82; }\n.strat-table td.neg { color: #e08a7a; }\n\n/* Stat tiles per strategy */\n.strat-tiles {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 12px;\n  margin: 16px 0 28px;\n}\n\n.strat-tile {\n  border: 1px solid #444;\n  border-radius: 10px;\n  padding: 14px 16px;\n}\n\n.strat-tile-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 10px;\n  gap: 8px;\n}\n\n.strat-tile-name {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.strat-tile-pnl {\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.strat-tile-bar-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.strat-tile-bar-track {\n  flex: 1;\n  height: 6px;\n  border-radius: 3px;\n  background: #333;\n  overflow: hidden;\n}\n\n.strat-tile-bar-fill {\n  height: 100%;\n  border-radius: 3px;\n}\n\n.strat-tile-pct {\n  font-size: 13px;\n  font-weight: 700;\n  min-width: 38px;\n  text-align: right;\n}\n\n.strat-tile-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11.5px;\n  opacity: 0.65;\n}\n\n.strat-section-title {\n  font-size: 15px;\n  margin: 24px 0 4px;\n}\n\n/* Discipline vs. outcome chart */\n.strat-discipline-chart {\n  margin: 14px 0 28px;\n  max-width: 640px;\n}\n\n.strat-chart-legend {\n  display: flex;\n  gap: 16px;\n  font-size: 12px;\n  opacity: 0.8;\n  margin-bottom: 10px;\n}\n\n.strat-chart-legend .dot {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  margin-right: 5px;\n}\n\n.strat-chart-legend .dot.win { background: var(--strat-good); }\n.strat-chart-legend .dot.loss { background: var(--strat-bad); }\n\n.strat-chart-row {\n  display: grid;\n  grid-template-columns: 150px 1fr auto;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.strat-chart-label {\n  font-size: 12.5px;\n  opacity: 0.85;\n}\n\n.strat-chart-track {\n  display: flex;\n  height: 16px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #2a2a2a;\n  min-width: 20px;\n}\n\n.strat-chart-seg {\n  height: 100%;\n}\n\n.strat-chart-seg.win { background: var(--strat-good); }\n.strat-chart-seg.loss { background: var(--strat-bad); }\n.strat-chart-seg.win + .strat-chart-seg.loss { border-left: 2px solid #1a1a1a; }\n\n.strat-chart-count {\n  font-size: 12px;\n  opacity: 0.7;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
